export default __webpack_public_path__ + "assets/82b1212e45a2bc35dd731913b27ad813.woff";